module.exports = __webpack_public_path__ + "static/img/about-mobile.87421ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-mobile.jpg
// module id = SXzc
// module chunks = 0